{<template>
    <section class="card card-info card-outline mb-0" role="region">
        
        <div class="card-header">
            <h3 class="card-title">Streams</h3>
        </div>
        
        <table class="table table-sm table-striped table-responsive">
            <colgroup>
                <col style="width: 2%;">
                <col style="width: 78%;">
                <col style="width: 20%;">
            </colgroup>

            <!-- //imple multiple mount point:station.mounts.length > 0 -->
            <template v-if="mounts.length > 0">
                <thead>
                <tr>
                    <th colspan="2"><small>Local Streams</small></th>
                    <th><small>Listeners</small></th>
                </tr>
                </thead>
                <tbody>
                <tr class="align-middle" v-for="(mount,i) in mounts" :key="i">
                    <td class="p-2">
                        <a class="btn-audio has-listener" href="#" v-bind:data-url="mount.url" @click.prevent="toggle(mount.url)">
                            <i class="text-info fa fa-play-circle"></i>
                        </a>
                    </td>
                    <td class="p-2">
                        <h6 class="mb-0">{{ mount.name }}</h6>
                        <a class="text-info small" v-bind:href="mount.url" target="_blank">{{ mount.url }}</a>
                    </td>
                    <td class="p-2 text-right">
                        <i class="fa fa-headphones mr-2"></i>
                        <span class="listeners-total">{{ listeners.total }}</span><br>
                        <small>
                            <span class="small listeners-unique">{{ listeners.unique }}</span>
                           Unique
                        </small>
                    </td>
                </tr>
                </tbody>
            </template>

        </table>
        <div class="card-footer">
        <div class="card-actions">
            <a @click.prevent="downloadPlist('audio/x-scpls')" class="btn btn-outline-info btn-sm  mr-2">
                <i class="fas fa-download"></i>
                Download PLS
            </a>
            <a @click.prevent="downloadPlist('audio/x-mpegurl', 'm3u')" class="btn btn-outline-info btn-sm">
                <i class="fas fa-download"></i>
                Download M3U
            </a>
        </div>
        </div>
    </section>
</template>

<script>

import downloadPlaylist from '@/plugins/downloadPlaylist'
export default {

    methods: {

        toggle (url) {
            // this.$eventHub.$emit('player_toggle', url);
        },

        downloadPlist(format, query){
            downloadPlaylist(this.station,format, query)
        }

    },


};
</script>
}